export const navigationTranslations = {
    en: {
        tabs: {
            watches: "watches",
            jewellery: "jewellery",
            tourmalines: "tourmalines",
            philosophy: "philosophy",
            maison: "maison",
            important_objects: "important objects",
            stores: "stores"
        },
        subtabs: {
            collections: "collections",
            movements: "movements",
            elements: "elements",
            rings: "rings",
            bracelets: "bracelets",
            necklaces: "necklaces",
            earrings: "earrings",
            made_to_order: "made to order",
            company: "company",
            our_innovations: "our innovations",
            commitments: "commitments",
            the_biggest_gemstone: "The biggest gemstone",
            stores: "stores",
            philosophy: "philosophy",
            tourmalines: "tourmalines",
        },
        products: {
            // Watches
            lucidity: "LUCIDITY",
            introsistence: "INTROSISTENCE",
            determination: "DETERMINATION",
            realization: "REALIZATION",
            connaissance: "CONNAISSANCE",
            essence_desthetique: "ESSENCE D'ESTHÉTIQUE",
            // Movements
            atomic: "ATOMIC",
            clockworklight: "LIGHT",
            tourmaline: "TOURMALINE",
            // Elements
            cypher_glass: "CYPHER GLASS",
            diamond_glass: "DIAMOND GLASS",
            tourmaline_frequencies: "TOURMALINE FREQUENCIES",
            // Jewellery Collections
            snake: "snake",
            fluoring: "fluoring",
            chinese_zodiacs: "chinese zodiacs",
            // Philosophy
            vision: "VISION",
            books: "BOOKS",
            // Company
            our_story: "OUR STORY",
            // Innovations
            floating_figures: "FLOATING FIGURES",
            innovation_diamond_glass: "DIAMOND GLASS",
            innovation_light_watch: "GEM CUTS",
            innovation_tourmaline_frequencies: "TOURMALINE FREQUENCIES",
            innovation_special_cuts: "LIGHT WATCH",
            the_biggest_gemstone: "THE SECRET RAINBOW"
        }
    },
    de: {
        tabs: {
            watches: "uhren",
            jewellery: "schmuck",
            tourmalines: "turmaline",
            philosophy: "philosophie",
            maison: "haus",
            important_objects: "herausragende Objekte",
            stores: "geschäfte"
        },
        subtabs: {
            collections: "kollektionen",
            movements: "uhrwerk",
            elements: "komponenten und elemente",
            rings: "ringe",
            bracelets: "armbänder",
            necklaces: "halsketten",
            earrings: "ohrringe",
            made_to_order: "nach maß",
            company: "unternehmen",
            our_innovations: "unsere innovationen",
            commitments: "verpflichtungen",
            the_biggest_gemstone: "Der größte Edelstein",
            stores: "geschäfte",
            philosophy: "philosophie",
            tourmalines: "turmaline",
            clockwork: "uhrwerke",
        },
        products: {
            // Watches
            lucidity: "LUCIDITY",
            introsistence: "INTROSISTENCE",
            determination: "DETERMINATION",
            realization: "REALIZATION",
            connaissance: "CONNAISSANCE",
            essence_desthetique: "ESSENCE D'ESTHÉTIQUE",
            // Movements
            atomic: "atomuhr",
            clockworklight: "lichtuhr",
            tourmaline: "TOURMALINE",
            // Elements
            cypher_glass: "CYPHER GLASS",
            diamond_glass: "DIAMOND GLASS",
            tourmaline_frequencies: "TOURMALINE FREQUENCIES",
            // Jewellery Collections
            snake: "snake",
            fluoring: "fluoring",
            chinese_zodiacs: "chinesische tierkreiszeichen",
            // Philosophy
            vision: "VISION",
            books: "BÜCHER",
            // Company
            our_story: "UNSERE GESCHICHTE",
            // Innovations
            floating_figures: "FLOATING FIGURES",
            innovation_diamond_glass: "DIAMOND GLASS",
            innovation_light_watch: "LIGHT WATCH",
            innovation_tourmaline_frequencies: "TOURMALINE FREQUENCIES",
            innovation_special_cuts: "LIGHT WATCH",
            the_biggest_gemstone: "Der größte Edelstein",
            stores: "geschäfte",
            tourmalines: "turmaline",
        }
    }
}; 